<div class="vertical" [@backgroundChange]="showNewImage ? 'hide' : 'show'"
     [style.backgroundImage]="'url('+ backgroundImage +')'"></div>
<div class="vertical new-background" [@backgroundChange]="showNewImage ? 'show' : 'hide'"
     [style.backgroundImage]="'url('+ newBackgroundImage +')'"></div>
<div class="router-outlet-container" [@routeAnimations]="o && o.activatedRouteData['animation']">
  <div class="center">
    <mat-card [ngClass]="customCardClass">
      <router-outlet #o="outlet"></router-outlet>
    </mat-card>
  </div>
</div>
<img src="assets/logo_.png" class="logo" alt="DLA ICT logo" (click)="navigateToLanding()">
